import Image from 'next/image';

import { ImageWithPlaceholder } from '@/components/ImageWithPlaceholder';
import { LinkButtonThemes, SecondaryLinkButton } from '@/components/buttons';
import checkmarkIcon from '@/public/icons/checkmarkIconAlt.svg';

type ProductDetailsCardProps = {
  title: string;
  bulletPoints: string[];
  image: string;
  ctaUrl: string;
  ctaLabel: string;
};

export default function ProductDetailsCard({
  bulletPoints,
  title,
  image,
  ctaLabel,
  ctaUrl,
}: ProductDetailsCardProps) {
  return (
    <div>
      <h2 className="text-teal-40 border-b border-grey-60 pb-5">{title}</h2>
      <div className="lg:flex mt-5">
        <ImageWithPlaceholder
          width="290"
          height="192"
          className="rounded-lg object-cover object-center w-full lg:w-[290px]"
          src={image}
          alt="card-image"
        />
        <div className="flex flex-col justify-center lg:items-center mt-6 lg:ml-6">
          <ul className="grid lg:grid-cols-2">
            {bulletPoints.map((bullet, index) => (
              <li key={index} className="flex items-center mb-2.5">
                <Image
                  className="mr-[5px]"
                  src={checkmarkIcon}
                  alt="checkmark-icon"
                  aria-hidden="true"
                />
                <p className="text-teal-40">{bullet}</p>
              </li>
            ))}
          </ul>
          <div className="mt-5 self-start">
            <SecondaryLinkButton
              theme={LinkButtonThemes.NewMain}
              className="px-12"
              data-testid="product-details-cta"
              href={ctaUrl}
            >
              {ctaLabel}
            </SecondaryLinkButton>
          </div>
        </div>
      </div>
    </div>
  );
}
